import React, { useEffect, useState } from 'react';
import { Button, Spinner, Container, Row, Col } from 'react-bootstrap';
import { _apiUrls } from '../utils/endpoints/apiUrls';
import { apiRequest } from '../utils/config/apiRequest';
import { ChromePicker } from 'react-color';
import { showMessage } from '../utils/helpers/toastHelpers';
import { _toastVariants } from '../utils/constants/constants';
import CustomModal from '../common/CustomModal';


export default function ColorPicker() {
    const [colors, setColors] = useState({
        rows: [],
        loading: false
    });
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 8,
        total: 0,
    });

    const [deleteColor, setDeleteColor] = useState({
        showModal: false,
        selectedColor: null,
        loading: false,
    });

    const [showPicker, setShowPicker] = useState(false);
    const [newColor, setNewColor] = useState('');
    const [savingLoader, setSavingLoader] = useState(false);

    useEffect(() => {
        fetchColorData();
    }, []);


    const fetchColorData = async () => {
        setColors(prev => ({ ...prev, loading: true }));
        try {
            const { data, status } = await apiRequest({
                endUrl: _apiUrls.backgroundColor,
                method: 'GET',
                query: {
                    page: pagination.page,
                    limit: pagination.limit,
                },
            });
            if (status) {
                setColors({ ...colors, rows: data?.rows });
                setPagination(prev => ({
                    ...prev,
                    total: data?.total || 0,
                }));
            }
        } catch (error) {
            console.error('Error fetching colors:', error);
        } finally {
            setColors(prev => ({ ...prev, loading: false }));
        }
    };


    const handleColorAdd = async () => {
        try {
            if (!newColor) {
                alert("Please select a color before saving.");
                return;
            }
            setSavingLoader(true)
            const { data, status, message } = await apiRequest({
                endUrl: _apiUrls.backgroundColorAdd,
                method: 'POST',
                body: { name: newColor },
            });
            setSavingLoader(false)
            if (status) {
                setShowPicker(false);
                setNewColor('');
                fetchColorData();
                showMessage('Color added successfully!', _toastVariants.Success);
            }
        } catch (error) {
            console.error('Error adding color:', error);
        }
    };

    // Delete Color ------------------------------

    const handleDeleteColor = async () => {
        try {
            setDeleteColor(prev => ({ ...prev, loading: true }));
            const { status } = await apiRequest({
                endUrl: _apiUrls.backgroundColorDelete,
                method: 'PUT',
                query: { id: deleteColor.selectedColor._id },
            });
            if (status) {
                setDeleteColor({ showModal: false, selectedColor: null, loading: false });
                fetchColorData();
                showMessage('Background color deleted successfully!', _toastVariants.Success);
            }
        } catch (error) {
            console.error('Error deleting color:', error);
            setDeleteColor(prev => ({ ...prev, loading: false }));
        }
    };




    return (
        <Container className="py-4" style={{}}>
            <Row style={{ alignItems: 'center' }}>
                <Col md={12}>
                    <h5 className="mb-sm-5 mb-4 choose-heading">Background Color</h5>
                </Col>
                <Col md={9}>
                    {colors.loading ? (
                        <Spinner animation="border" variant="light" />
                    ) : (
                        <Row className="g-3">
                            {colors?.rows?.map((color, index) => (
                                <Col key={index} xs="auto">
                                    <div className='choose-color'
                                        onClick={() => {
                                              setDeleteColor({
                                                showModal: true,
                                                selectedColor: color,
                                                loading: false,
                                            });
                                        }}
                                        style={{
                                            backgroundColor: color.name,
                                            cursor: 'pointer',
                                        }}
                                    ></div>
                                </Col>
                            ))}
                        </Row>
                    )}
                </Col>

                <Col md={3} className='text-sm-end mt-sm-0 mt-4'>
                    <div className="position-relative">
                        <Button variant="primary" size="sm"
                            onClick={() => setShowPicker(!showPicker)}
                            style={{
                                background: 'rgba(75, 128, 235, 1)',
                                borderColor: "rgba(75, 128, 235, 1)",
                                padding: "5px 19px",
                                borderRadius: "7px",
                                fontSize: 13
                            }}>
                            + Add Colors
                        </Button>

                        {showPicker && (
                            <div className="color-pallate">
                                <ChromePicker
                                    color={newColor}
                                    onChangeComplete={(color) => setNewColor(color.hex)}
                                />
                                <div style={{ display: 'flex', justifyContent: 'center', marginTop: '5px' }}>
                                    <Button
                                        className="mt-2"
                                        variant="primary"
                                        size="sm"
                                        style={{
                                            background: 'rgba(75, 128, 235, 1)',
                                            borderColor: "rgba(75, 128, 235, 1)",
                                            padding: "5px 19px",
                                            borderRadius: "7px",
                                            fontSize: 13
                                        }}
                                        onClick={handleColorAdd}
                                    >
                                        {savingLoader ? (
                                            <Spinner animation="border" size="sm" />
                                        ) : (
                                            'Save Color'
                                        )}
                                    </Button>
                                </div>
                            </div>
                        )}
                    </div>
                </Col>
            </Row>

            {/* Delete Color Modal ------------------------------- */}

            <CustomModal
                show={deleteColor.showModal}
                onHide={() => setDeleteColor(prev => ({ ...prev, showModal: false }))}
                title="Delete Background Color"
                showCloseButton={true}
                footerButtons={
                    <>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', width: '100%' }}>
                            <Button variant="secondary" style={{ padding: "5px 30px" }}
                                onClick={() => setDeleteColor(prev => ({ ...prev, showModal: false }))}
                            >
                                Cancel
                            </Button>
                            <Button variant="danger" style={{ padding: "5px 30px" }} onClick={handleDeleteColor}>
                                {deleteColor.loading ? <Spinner animation="border" size="sm" /> : 'Delete'}
                            </Button>
                        </div>
                    </>
                }
            >

                {deleteColor.selectedColor && (
                    <div className='my-3'>
                        <p className='text-center textwhite mb-2' style={{ fontSize: 16 }}>Are you sure you want to delete this background color</p>
                        <div className='choose-color ' style={{
                            margin: '0 auto',
                            backgroundColor: deleteColor?.selectedColor?.name
                        }} />
                    </div>
                )}
            </CustomModal>




        </Container>
    );
}
